import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';

const routes: Routes = [
  { path: '', redirectTo: '/user/dashboard2/sales', pathMatch: 'full' },
  {
    path: 'login',
    loadChildren: () =>
      import('./modules/login/login.module').then(
        (module) => module.LoginModule
      ),
  },
  {
    path: 'client/service-request/:client_id/:company_id',
    loadChildren: () =>
      import('./modules/client-service-list/client-service-list.module').then(
        (module) => module.ClientServiceListModule
      ),
  },
  {
    path: 'client/service-request/:client_id/:company_id/:service_request_id',
    loadChildren: () =>
      import('./modules/chat-screen/chat-screen.module').then(
        (module) => module.ChatScreenModule
      ),
  },
  {
    path: 'promotions/client/company/:client_id/:company_id/:promotion_id',
    loadChildren: () =>
      import(
        './modules/promotion-client-screen/promotion-client-screen.module'
      ).then((module) => module.PromotionClientScreenModule),
  },
  { path: 'user', redirectTo: '/user/dashboard2/sales', pathMatch: 'full' },
  {
    path: 'user',
    loadChildren: () =>
      import('./modules/layout/layout.module').then(
        (module) => module.LayoutModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'sign-up',
    loadChildren: () =>
      import('./modules/sign-up/sign-up.module').then(
        (module) => module.SignUpModule
      ),
  },
  {
    path: 'terms-and-conditions',
    loadChildren: () =>
      import('./modules/terms-and-conditions/terms-and-conditions.module').then(
        (module) => module.TermsAndConditionsModule
      ),
  },
  {
    path: 'admin',
    redirectTo: '/admin/on-boarding',
    pathMatch: 'full',
  },
  {
    path: 'admin',
    loadChildren: () =>
      import('./modules/admin/layout/layout.module').then(
        (module) => module.LayoutModule
      ),
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
